import React from "react";

const paperturnUrlAfterLogin = "https://www.paperturn-view.com/?pid=MzA309919&v=2&bgcolor=%23f1f1f1&embed=script&shadow=&flipSound=&hardCover=";
const screenReaderDownloadLink = `https://www.mckinsey.com/spcontent/bespoke/state-of-org/pdf/mck-soo-accessible-web.pdf`

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      pushEvent(event);
    }
  }

  const pushEvent = (event) => {
    if (window.appEventData) {
      window.appEventData.push({
        "event": "Navigation Link Clicked",
        "linkInfo": {
          "regions": "download",
          "text": event.currentTarget.dataset.layerText,
          "action": "keypress",
          "category": "Download accessible PDF",
          "region": "Prepoulated Search field"
        }
      });
    }
  }

export default function FirstSection() {
  return (
    <section className="quarterly">
      <div className="wrapper">
        <div className="mck-o-container--wrapped">
          <div className="paper-link mck-u-links-inline">
            <div>
              <div aria-hidden="false">
                <div className="visually-hidden">
                  <p>Screen reader users: <br/>An accessible version of the full State of Organizations report is available via
										<a href={screenReaderDownloadLink} 
											target="_self" 
											className="visually-hidden" 
											data-layer-event-prefix="Navigation Link" 
											data-layer-action="click" 
											data-layer-text="Download accessible PDF here" 
											onKeyDown={handleKeyDown}>
											this link.
										</a>
										This PDF contains alt text for illustrations, charts and graphs. Its table of contents contains links to all articles. 
										In order to most efficiently navigate this document, we recommend the following:
									</p>
                  <ol>
                    <li>
                      Download and save the file to your computer.
                    </li>
                    <li>
                      If you’d like to see the list of all chapters in this report, jump by heading until you hear “Contents.”
                    </li>
                    <li>
                      Once you’ve explored the list and found a chapter you’d like to read, select its link by tabbing to it and pressing Enter.
                    </li>
                    <li>
                      To return to the table of contents, go to the list of headings, and begin typing “Contents.” Press enter when you hear the heading with this title spoken.
                    </li>
                  </ol>
                  <p>If you have questions or encounter any difficulty with this PDF, you can reach us at: <a href="mailto:McKinsey_Website_Accessibility@mckinsey.com" target="_blank" rel="noreferrer">McKinsey_Website_Accessibility@mckinsey.com</a>.</p>
                </div>
              </div>
              <div aria-hidden="true">
                <a href={paperturnUrlAfterLogin} 
									target="_self" 
									aria-hidden="true" 
									data-layer-event-prefix="Navigation Link" 
									data-layer-action="click" 
									data-layer-text="Tablet, mobile, and screen reader users click here">
                  Tablet, mobile, and screen reader users click here
                </a>
							</div>
							<div aria-hidden="false">
								<a href={screenReaderDownloadLink} 
									target="_self" 
									className="visually-hidden" 
									data-layer-event-prefix="Navigation Link" 
									data-layer-action="click" 
									data-layer-text="Screen reader users click here">
									Download accessible PDF here
								</a>
              </div>
            </div>
          </div>
        </div>
        <div className="content-grid">
          <div className="quarterly-container">
            {/* default paper turn for sample */}
            {/* Full edition for after users sign in */}
            <iframe 
              title={'paperturn'}
              src={paperturnUrlAfterLogin}
              width="100%" 
              allowfullscreen="true" 
              webkitallowfullscreen="true" 
              mozallowfullscreen="true" 
              className="paperTurn-iframe">
              </iframe>
          </div>
        </div>
      </div>
    </section>
  );
}
